import { render, staticRenderFns } from "./InvitationCard.vue?vue&type=template&id=1c375da6&scoped=true"
import script from "./InvitationCard.vue?vue&type=script&lang=js"
export * from "./InvitationCard.vue?vue&type=script&lang=js"
import style0 from "./InvitationCard.vue?vue&type=style&index=0&id=1c375da6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c375da6",
  null
  
)

export default component.exports